var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshakeSvgrepo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7809 16.9771C20.2734 13.9478 18.823 11.1559 16.6363 8.99893C16.1575 8.53317 15.9187 8.30075 15.3899 8.08593C14.8612 7.87018 14.4065 7.87018 13.4982 7.87018H11.5018C10.5934 7.87018 10.1388 7.87018 9.61003 8.08593C9.08223 8.30075 8.84148 8.53317 8.36368 8.99893C6.17697 11.1559 4.72658 13.9478 4.21905 16.9771C3.76811 19.6976 6.27748 21.7597 9.08131 21.7597H15.9187C18.7234 21.7597 21.2337 19.6976 20.78 16.9771",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0065 13.351C13.8065 12.6111 12.787 11.9444 11.5638 12.4435C10.3406 12.9426 10.1471 14.5473 11.9963 14.7186C12.8333 14.7955 13.3778 14.6288 13.8769 15.1001C14.3769 15.5705 14.4695 16.8808 13.1926 17.2336C11.9175 17.5864 10.6536 17.0354 10.5166 16.252M12.3537 11.5667V12.2713M12.3537 17.3419V18.0494M8.10811 5.50249C7.91644 5.2247 7.63957 4.84691 8.21182 4.76172C8.79981 4.67283 9.41002 5.0747 10.0082 5.06729C10.548 5.05896 10.8231 4.81913 11.1194 4.47652C11.4305 4.11632 11.912 3.24036 12.5 3.24036C13.088 3.24036 13.5695 4.11632 13.8806 4.47652C14.1769 4.81913 14.4519 5.05988 14.9918 5.06636C15.5899 5.07562 16.2001 4.67283 16.7881 4.76079C17.3604 4.84691 17.0835 5.22378 16.8918 5.50157L16.0288 6.75996C15.6585 7.29702 15.4742 7.56555 15.0871 7.71833C14.7001 7.87112 14.201 7.87019 13.2019 7.87019H11.7981C10.798 7.87019 10.299 7.87019 9.91282 7.71833C9.5267 7.56648 9.3415 7.29609 8.97112 6.75903L8.10811 5.50249Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshakeSvgrepo);
export default __webpack_public_path__ + "static/media/handshake-svgrepo.87852ca8a702f76da7832e0d9447cec1.svg";
export { ForwardRef as ReactComponent };